import(/* webpackMode: "eager" */ "/home/node/app/src/app/[locale]/(manual)/manual/[slug]/loading.tsx");
